<template>
  <div class="sect-section">
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 text-center">
          <h1 class="sect-title">Jogos no Mundo das Trevas</h1>
          <p class="lead" style="color: #e9ecef;">
            Explore adaptações de Vampiro: A Máscara que atravessam tabuleiros, consoles e PCs para inspirar
            novas crônicas.
          </p>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-md-6 col-lg-4" v-for="game in games" :key="game.id">
          <article class="card game-card h-100">
            <div class="game-cover" :style="{ backgroundImage: `url(${game.image})` }">
              <span class="badge bg-dark text-warning text-uppercase">{{ game.type }}</span>
            </div>
            <div class="card-body d-flex flex-column">
              <h5 class="card-title">{{ game.title }}</h5>
              <p class="small text-muted mb-2">{{ game.releaseYear }} • {{ game.platform }}</p>
              <p class="card-text flex-grow-1">{{ game.description }}</p>
              <ul class="list-inline small text-muted mb-3">
                <li class="list-inline-item me-3" v-for="tag in game.tags" :key="tag">
                  <i class="bi bi-record-circle me-1 text-danger"></i>{{ tag }}
                </li>
              </ul>
              <a :href="game.link" class="btn btn-outline-light w-100 mt-auto" target="_blank" rel="noopener">
                Saiba mais
              </a>
            </div>
          </article>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12">
          <div class="lore-card">
            <h5 class="lore-card-title">
              <i class="bi bi-controller me-2"></i>
              Inspiração para suas mesas
            </h5>
            <p class="mb-0 text-muted">
              Adapte enredos, antagonistas e atmosferas desses jogos para construir campanhas memoráveis — das
              ruas decadentes de Los Angeles às cruzadas fanáticas do Sabbat em Praga.
            </p>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button class="btn btn-outline-light" @click="$emit('go-back')">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vMRivalsCardGame from '../assets/gamesImages/vm_rivals_card_game.jpg'
import vMChaptersBoardGame from '../assets/gamesImages/vm_chapters_board_game.jpg'
import vMRedemption from '../assets/gamesImages/vm_redemption.jpg'
import vMBloodlines from '../assets/gamesImages/vm_bloodlines.jpg'

export default {
  name: 'GamesView',
  data() {
    return {
      games: [
        {
          id: 'rivals',
          title: 'Vampire: The Masquerade Rivals',
          type: 'Jogo de Cartas',
          platform: 'jogo de cartas de 2 a 4 jogadores',
          releaseYear: 2022,
          description:
            'Os jogadores controlam um grupo de vampiros de diferentes clãs, competindo pelo controle da cidade através de diversas habilidades, ataques e planos para alcançar a vitória, marcando 13 pontos de Agenda ou eliminando o Prestígio do rival. O jogo pode ser personalizado e expandido com novas cartas e conteúdo lançados regularmente.',
          tags: ['Prestígio', 'Gestão de clãs', 'White Wolf Licensed'],
          image: vMRivalsCardGame,
          link: 'https://www.amazon.com.br/Renegade-Game-Studios-Masquerade-Expandable/dp/B08HRKLLQM/ref=asc_df_B08HRKLLQM?mcid=5668c834beba32fe89da61416be621ee&tag=googleshopp00-20&linkCode=df0&hvadid=709857019587&hvpos=&hvnetw=g&hvrand=4739393650364443278&hvpone=&hvptwo=&hvqmt=&hvdev=c&hvdvcmdl=&hvlocint=&hvlocphy=9102131&hvtargid=pla-1195393560906&psc=1&language=pt_BR&gad_source=1'
        },
        {
          id: 'chapters',
          title: 'Vampire: The Masquerade — Chapters',
          type: 'Jogo de Tabuleiro',
          platform: 'Narrativo cooperativo em Montreal',
          releaseYear: 2022,
          description:
            'A história se passa em Montreal, após o surgimento da Segunda Inquisição e a queda do Sabá. Estruturado em torno de três pilares — narrativa, estratégia e interpretação de papéis — o jogo combina os melhores elementos de RPGs e jogos de tabuleiro de uma forma totalmente inovadora. As decisões dos jogadores moldarão a aventura em uma narrativa envolvente e madura.',
          tags: ['Campanha cooperativa', 'Narrativa', 'White Wolf Licensed'],
          image: vMChaptersBoardGame,
          link: 'https://www.amazon.com.br/Vampire-Masquerade-Chapters-Cooperative-Story-Driven/dp/B0C258R7VC/ref=sr_1_1?__mk_pt_BR=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=3JNO8AJER9KJ2&dib=eyJ2IjoiMSJ9.8-tx86nqSH_GF2eKMAgqcQ.c0myN809MBKbFI7iDnwTNC_DxcGCgikQnEACSA1YrvU&dib_tag=se&keywords=Vampire%3A+The+Masquerade+%E2%80%94+Chapters&qid=1764616242&s=toys&sprefix=vampire+the+masquerade+chapters%2Ctoys%2C376&sr=1-1&ufe=app_do%3Aamzn1.fos.25548f35-0de7-44b3-b28e-0f56f3f96147'
        },
        {
          id: 'redemption',
          title: 'Vampire: The Masquerade — Redemption',
          type: 'Jogo Digital',
          platform: 'PC (2000) • Nihilistic Software',
          releaseYear: 2000,
          description:
            'A jornada de Christof Romuald atravessa séculos até a noite moderna, apresentando clãs icônicos e dilemas éticos que podem ser traduzidos para crônicas de mesa.',
          tags: ['RPG de ação', 'História canônica', 'White Wolf'],
          image: vMRedemption,
          link: 'https://www.gog.com/en/game/vampire_the_masquerade_redemption'
        },
        {
          id: 'bloodlines',
          title: 'Vampire: The Masquerade — Bloodlines',
          type: 'Jogo Digital',
          platform: 'PC (2004) • Troika Games',
          releaseYear: 2004,
          description:
            'Clássico cult que mergulha nos conflitos de Los Angeles com forte presença da White Wolf. Excelente referência para diálogos, política e ambientação urbana.',
          tags: ['RPG imersivo', 'Camarilla vs. Anarquistas', 'White Wolf'],
          image: vMBloodlines,
          link: 'https://www.gog.com/en/game/vampire_the_masquerade_bloodlines'
        }
      ]
    }
  }
}
</script>

<style scoped>
.game-card {
  background: rgba(15, 15, 15, 0.94);
  border: 1px solid rgba(139, 0, 0, 0.35);
  color: #f8f9fa;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.game-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);
}

.game-cover {
  position: relative;
  padding-top: 56.25%;
  background-size: cover;
  background-position: center;
  border-bottom: 1px solid rgba(139, 0, 0, 0.35);
}

.game-cover .badge {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  letter-spacing: 0.08em;
}
</style>
